import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * Dispatched when a 3S request is completed.
 */
const onServiceResponse = action(
    'onServiceResponse',
    (scenarioId: SearchScenarioId, traceId: string, isQFTraceId: boolean) => ({
        scenarioId,
        traceId,
        isQFTraceId,
    })
);

export default onServiceResponse;
